import Cookies from 'js-cookie' 
import store from '@/store'
import router from '@/router'




//获取cookie
export function getCookies(val){return Cookies.get(val)}
//删除cookie
export function delCookies(val){Cookies.remove(val)}


//获取session中的Token
// export function getSessionToken(){return JSON.parse(sessionStorage.getItem('token'))}
export function getSessionToken(){return sessionStorage.getItem('token')}
//向session中写入Token
// export function setSessionToken(val){sessionStorage.setItem('token',JSON.stringify(val))}
export function setSessionToken(val){sessionStorage.setItem('token',val)}

export function userLogout(){ 
    store.commit('app/SET_USERNAME','')
    store.commit("app/CLEAR_TABS");
    sessionStorage.clear()  
    router.push('/login')  
}